import ConnectImageDark from 'assets/portfolio/connect-dark.png'
import ConnectImageLight from 'assets/portfolio/connect-light.png'
import { Image } from 'components'
import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks'
import React from 'react'
import { useStore } from 'services/store'
import {
  ConnectButton,
  ConnectImageContainer,
  ConnectImageWrapper,
  ConnectTagline,
  ConnectTitle,
  ConnectWrapper,
  ContainerImage,
  ContentTextWrapper,
  EmphasisSpan,
} from './styled'

export const InvestPortfolioWrapper: React.FC = () => {
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.Portfolio)
  const { isDarkMode } = useStore()
  /**
   * This click only gets called if we have no wallet or no balance.
   */
  const handleClick = () => {
    return navigationEvent('/#content')
  }
  return (
    <ConnectWrapper>
      <ContentTextWrapper>
        <ConnectTitle>
          Connect. <EmphasisSpan>Invest. </EmphasisSpan> Earn.
        </ConnectTitle>
        <ConnectTagline>
          Phuture&apos;s products provide easy exposure to the crypto market
        </ConnectTagline>
        <ConnectButton buttonType="primary" onClick={handleClick}>
          Buy now
        </ConnectButton>
      </ContentTextWrapper>
      <ContainerImage>
        <ConnectImageContainer>
          <ConnectImageWrapper>
            <Image
              src={isDarkMode ? ConnectImageDark : ConnectImageLight}
              alt={'Image of Phuture products laid out like cards'}
            />
          </ConnectImageWrapper>
        </ConnectImageContainer>
      </ContainerImage>
    </ConnectWrapper>
  )
}
